<div class="banner-area banner-img-one">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="banner-item">
                            <div class="banner-left">
                                <h1>Attorneys Fight For Your Justice</h1>
                                <p>Our Professional Attorneys are devoted to your Progress & to achieve your Goal. Our Law Firm supports our clients for various versatile cases and to get justice.</p>
                                <a [routerLink]="routesUrl.contactUrl">FREE CONSULTATION <i class="icofont-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="banner-bottom">
            <ul>
                <li><i class="flaticon-leader"></i></li>
                <li>
                    <span>100% Legal</span>
                    <p>Govt Approved</p>
                    <img src="assets/img/home-one/9.png" alt="Shape">
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="help-area pb-70" style="margin-top: -7% !important">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="help-item" style="margin-left: 8%;">
                    <img src="assets/img/Main-layout/home-2.webp" height="450px" style="border: 20px solid #b69d74;" alt="Help">
                </div>
            </div>

            <div class="col-lg-6">
                <div class="help-item">
                    <div class="help-right">
                        <h2>We Provide Qualified Attorneys For Your Assistance </h2>
                        <p>Our Whole Team brings a strong and fearless attitude to all the clients they assist. And, to make sure that you win, our team will provide you with High-quality service.</p>
                        <div class="help-inner-left">
                            <ul>
                                <li><i class="flaticon-checkmark"></i> Browse Our Website</li>
                                <li><i class="flaticon-checkmark"></i> Choose Services</li>
                            </ul>
                        </div>

                        <div class="help-inner-right">
                            <ul>
                                <li><i class="flaticon-checkmark"></i> Quick Reply</li>
                                <li><i class="flaticon-checkmark"></i> Best Performances</li>
                            </ul>
                        </div>

                        <div class="help-signature">
                            <img src="assets/img/about/sign.png" alt="Signature" height="130px">
                        </div>

                        <a class="cmn-btn" [routerLink]="routesUrl.practiceUrl">Learn More</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="help-shape">
            <img src="assets/img/home-one/6.png" alt="Shape">
        </div>
    </div>
</div>

<section class="expertise-area">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="section-title text-start">
                    <!-- <span>OUR EXPERTISE</span> -->
                    <h2>Law Firm Devoted To Our Clients</h2>
                </div>

               <div class="expertise-item">
                    <ul>
                        <li class="wow fadeInUp" data-wow-delay=".3s">
                            <div class="expertise-icon">
                                <i class="flaticon-experience"></i>
                                <img src="assets/img/home-one/11.png" alt="Shape">
                            </div>
                            <h3>Experience</h3>
                            <p>Our Attorneys are incredibly professional and understand the situation of their clients and encourage them until obtaining victory</p>
                        </li>

                        <li class="wow fadeInUp" data-wow-delay=".4s">
                            <div class="expertise-icon">
                                <i class="flaticon-lawyer"></i>
                                <img src="assets/img/home-one/11.png" alt="Shape">
                            </div>
                            <h3>Skilled Attorney</h3>
                            <p>Our Attorneys are creative and skilled and it helps them to find a huge variety of solution to win</p>
                        </li>

                        <li class="wow fadeInUp" data-wow-delay=".5s">
                            <div class="expertise-icon">
                                <i class="flaticon-balance"></i>
                                <img src="assets/img/home-one/11.png" alt="Shape">
                            </div>
                            <h3>Legal Proces</h3>
                            <p>We maintain all the legal documents and papers and start to reach our destination in a legal way</p>
                        </li>
                    </ul>
               </div>
            </div>

            <div class="col-lg-6">
                <div class="expertise-image">
                    <img src="assets/img/Main-layout/test.jpg" alt="Expertise">
                </div>
            </div>
        </div>
    </div>
</section>


<section class="custom-margin" style="margin-top:7%;">
    <!-- <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="section-title text-start">
                    <span>OUR VALUABLE CLIENTS</span>
                    <h2>List Of Our Clients</h2>
                </div>
            </div>
        </div>
    </div> -->

    <div class="custom-carousel expertise-item wow fadeInUp">
        <owl-carousel
            [options]="{items: 3, dots: true, navigation: true, autoplay:true, autoplayTimeout:1500, autoplayHoverPause:true, loop: true}"
            [items]="images"
            [carouselClasses]="['owl-theme', 'row', 'sliding']">
            <div class="item" *ngFor="let image of images; let i = index">
                <div class="thumbnail-image">
                    <img [src]="image" height="220px"/>
                </div>
            </div>
        </owl-carousel>
    </div>
</section>

<div class="contact-form pb-100">
    <br /><br />

    <div class="container-fluid">
        <app-contact-form></app-contact-form>
    </div>
    <br /><br />
</div>